/**
 * Listing-page Request Booking enablement. In-flight units / line-items /
 * timeslot refetches must not pin the CTA disabled once the buyer has
 * already chosen an eligible tier (and, for hourly bookings, a slot).
 */

export const listingBookingCtaDisabled = ({
  priceTiersCatalog,
  hasEligibleTier,
  unitsAvailabilityKnown,
  openWithoutUnits,
} = {}) => !!priceTiersCatalog && !hasEligibleTier && (unitsAvailabilityKnown || !openWithoutUnits);

/**
 * Keep a buyer-selected tier while units for the current slot are still
 * loading. Dropping it on a stale/other-slot response is what left
 * Request Booking disabled after Standard + date + time (I2c / iPhone).
 */
export const keepSelectedTierDuringUnitsRefresh = ({
  currentTierId,
  currentTierEligible,
  unitsAvailabilityKnown,
  pickedTierId,
} = {}) => {
  if (currentTierId && (currentTierEligible || !unitsAvailabilityKnown)) {
    return currentTierId;
  }
  return pickedTierId || null;
};

export const bookingSubmitDisabledForLineItems = ({
  fetchLineItemsInProgress,
  hasSelectedTimes,
} = {}) => !!fetchLineItemsInProgress && !hasSelectedTimes;
